// extracted by mini-css-extract-plugin
module.exports = {"scrollbars":"styles_scrollbars__lcQUq","modal":"styles_modal__bvFin","slideInSearchBar":"styles_slideInSearchBar__CxNeg"};